import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import "../../assets/css/AccordionDemo.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getBank, getBanker, getBranch, getLoanFile, getLoanFileStatus, getProduct, getStateWiseCities, getUser } from "../../services/userMasterUser";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { formatDate } from "../../constants/FormateDate";
import { bankerListUpload } from "../../services/bankListUpload";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { getLeadSource, getLeadType } from "../../services/leads";
import { Calendar } from "primereact/calendar";

export default function AdminLoanFileList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const ds = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [stateCityList, setStateCityList] = useState({});

  const [productDataValue, setProductDataValue] = useState("");
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');

  const [productDataList, setProductDataList] = useState([])

  const citiesList = stateCityList[stateValue] || [];

  const [bankCategoryValue, setBankCategoryValue] = useState("")
  const [branchCategoryValue, setBranchCategoryValue] = useState("")
  const [recordTypeValue, setRecordTypeValue] = useState("RequestOn")
  const [leadTypeList, setLeadTypeList] = useState([])
  const [typeOfLead, setTypeOfLead] = useState('')
  const [userDataFilter, setUserDataFilter] = useState("");
  const [userDataIds, setUserDataIds] = useState([]);
  const [branchDataValue, setBranchDataValue] = useState("")
  const [branchDataList, setBranchDataList] = useState([])
  const [leadSourceValue, setLeadSourceValue] = useState("")
  const [leadSourceList, setLeadSourceList] = useState([])
  const [bankListData, setBankListData] = useState([])
  const [bankListAllData, setBankListAllData] = useState([])
  const [bankDataValue, setBankDataValue] = useState([])
  const [fileStatusData, setFileStatusData] = useState([]);
  const [fileStatusDataValue, setFileStatusDataValue] = useState([]);    

  const [bankerAllList, setBankerAllList] = useState([])
  const [bankerList, setBankerList] = useState([])
  const [bankerDataValue, setBankerDataValue] = useState([])

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 3); // subtract 7 days to current date

  const [startDateValue, setStartDateValue] = useState(new Date(initialStartDate));
  const [endDateValue, setEndDateValue] = useState(new Date());

  const recordTypeSelection = [
    { label: "CreatedOn", value: "CreatedOn" },
    { label: "LeadOn", value: "LeadOn" },
    { label: "FollowUpOn", value: "FollowUpOn" },
    { label: "ClosedOn", value: "ClosedOn" },
    { label: "RequestOn", value: "RequestOn" },
    { label: "SanctionOn", value: "SanctionOn" },
    { label: "DisbursedOn", value: "DisbursedOn" },
  ]


  const bankCategoryList = [
    { label: "Nationalised Bank", value: "Nationalised bank" },
    { label: "Private Bank", value: "Private Bank" },
    { label: "Financial Institution", value: "Financial Institution" },
    { label: "Small Bank", value: "Small Bank" },
    { label: "Alternative Investment Fund", value: "Alternative Investment Fund" },
  ]

  const branchCategoryDataList = [
    { label: "Normal", value: "Normal" },
    { label: "Agri", value: "Agri" },
    { label: "MSME", value: "MSME" },
    { label: "Mid-Corporate", value: "Mid-Corporate" },
    { label: "Large-Corporate", value: "Large-Corporate" },
  ]


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    requestedDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    requestAmount: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    fileStatus: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sanctionAmount: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sanctionOn: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    disbursedAmount: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    disbursedOn: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [searchByStatus, setSearchByStatus] = useState('requestedDate');

  const searchByStatusData = [
    { label: "Requested Date", value: "requestedDate" },
    { label: "Request Amount", value: "requestAmount" },
    { label: "File Status", value: "fileStatus" },
    { label: "Sanction Amount", value: "sanctionAmount" },
    { label: "Sanction On", value: "sanctionOn" },
    { label: "Disbursed Amount", value: "disbursedAmount" },
    { label: "Disbursed On", value: "disbursedOn" },
  ];

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: []
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getLoanFile(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          if (append) {
            setProducts((prev) => [...(prev || []), ...newData]);
          } else {
            setProducts(newData);
          }

          setTotalRecords(response.data.totalRecords || newData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const fetchBankerData = (bankerData) => {
  getBanker(bankerData)
    .then((response) => {
      if (!response.data.error) {
        const newData = response.data.data || response.data; // adjust if API structure differs

        const activeBanker = newData.filter((item) => item.status === "ACTIVE");
        const bankerDataList = activeBanker.map((item) => ({
          label: item?.city + "-" + item?.bank?.name + "-" + item?.bank?.category + "-" + item.nameOfBanker + "-" + item?.mobile + "-Limit: " + "Min-" + item?.minimumLoanAmount + ", Max-" + item?.maximumLoanAmount,
          value: item.id,
        }));

        setBankerAllList(bankerDataList);
        setBankerList(bankerDataList);

      } else {
        errorMessage("Invalid Credentials");
      }
    })
    .catch(() => {
      errorMessage();
    })
  }


  useEffect(() => {
    fetchData({
      ...typeData,
      limit: rows,
      offset: 0
    });

    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    const typeProductData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getProduct(typeProductData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const productData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setProductDataList(productData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
        }
      })
      .catch(() => errorMessage());

    const userData = {
      searchBy: "",
      searchText: "",
      limit: 1000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      userTypeIdIn: [],
      roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
      statusIn: ["ACTIVE"]

    };

    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
        }
      })
      .catch(() => {
        errorMessage();
      })

    const typeBranchData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getBranch(typeBranchData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const branchData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setBranchDataList(branchData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadSource = Res.map((item) => ({
            label: item,
            value: item,
          }));


          setLeadSourceList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })

    getBank()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          const bankList = Res.map((item) => ({
            label: item.name,
            value: item.id,
            category: item.category
          }));

          setBankListAllData(bankList)
          setBankListData(bankList)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })


    const bankerData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      // bankIdIn: []
    };

    fetchBankerData(bankerData)

      getLoanFileStatus()
            .then((response) => {
              if (!response.data.error) {
                const newData = response.data.data || response.data; // adjust if API structure differs
      
                const dataList = newData.map((item) => ({
                  label: item,
                  value: item,
                }));
      
                setFileStatusData(dataList);
      
              } else {
                errorMessage("Invalid Credentials");
              }
            })
            .catch(() => {
              errorMessage();
            })


  }, []);

  useEffect(() => {

    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    const hasValidFilter =
      stateValue ||
      cityValue ||
      startDateValue ||
      endDateValue ||
      // branchCategoryValue ||
      typeOfLead ||
      userDataFilter ||
      branchDataValue ||
      leadSourceValue ||
      recordTypeValue ||
      bankCategoryValue ||
      bankDataValue ||
      bankerDataValue ||
      fileStatusDataValue ||
      productDataValue;

    if (!hasValidFilter) return;

    const payload = {
      ...typeData,
      limit: rows,
      offset: 0,
      statusIn: [],
      // branchCategoryIn: branchCategoryValue ? branchCategoryValue : [],

      addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] },
      leadTypeIn: typeOfLead ? [typeOfLead] : [],
      fileStatusIn: fileStatusDataValue ? fileStatusDataValue :  [], // request , sanction , disbursed, diclined
      userIdIn: userDataFilter ? userDataFilter : [],
      branchIdIn: branchDataValue ? branchDataValue : [],
      productIn: productDataValue ? productDataValue : [],
      sourceIn: leadSourceValue ? leadSourceValue : [],
      recordType: recordTypeValue,
      startDate,
      endDate,
      bankCategoryIn: bankCategoryValue ? [bankCategoryValue] : [], // bank category if (bank category is selected then show bank id)
      bankIdIn:  bankDataValue ? bankDataValue : [], // bank list // multi if (bank id  is selected then show banker id)
      bankerIdIn: bankerDataValue ? bankerDataValue : [] // banker list
    };

    fetchData(payload);

  }, [
    stateValue,
    cityValue,
    startDateValue,
    endDateValue,
    // branchCategoryValue,
    productDataValue,
    fileStatusDataValue,
    typeOfLead,
    userDataFilter,
    branchDataValue,
    leadSourceValue,
    recordTypeValue,
    bankCategoryValue,
    bankDataValue,
    bankerDataValue,
  ]);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };

  // const onGlobalFilterChange = (e) => {
  //   const value = e.target.value;

  //   const _filters = { ...filters };
  //   _filters.global.value = value;

  //   setFilters(_filters);
  //   setGlobalFilterValue(value);

  //   fetchData({
  //     searchBy: "",
  //     searchText: value,
  //     limit: 20,
  //     offset: 0,
  //     sortBy: "",
  //     sortOrder: "desc",
  //     statusIn: []
  //   });
  // };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };


  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <h5 className="card-title flex">
                    <div
                      className="mr-3 cursor-pointer"
                      onClick={() => navigate("/operation-lead/list")}
                    >
                      <i class="bi bi-arrow-left-circle-fill"></i>
                    </div> Loan File List
                  </h5>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={productDataValue}
                        onChange={(e) => setProductDataValue(e.value)}
                        options={productDataList}
                        optionLabel="label"
                        placeholder="Select Product"
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        value={stateValue}
                        onChange={(e) => {
                          setStateValue(e.value);
                          setCityValue([])

                        }
                        }
                        options={stateCitiesList}
                        optionLabel="label"
                        placeholder="Select a State"
                        filter
                        filterDelay={400}
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={cityValue}
                        onChange={(e) => setCityValue(e.value)}
                        options={citiesList}
                        placeholder="Select City"
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={recordTypeSelection}
                        value={recordTypeValue}
                        placeholder="Select Record Type"
                        onChange={(e) => {
                          setRecordTypeValue(e.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">

                    {/*<div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        options={branchCategoryDataList}
                        value={branchCategoryValue}
                        onChange={(e) =>
                          setBranchCategoryValue(e.value)}
                        optionLabel="label"
                        placeholder="Select Branch Category"
                      />
                    </div>*/}


                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={leadTypeList}
                        value={typeOfLead}
                        placeholder="Select Lead Type"
                        onChange={(e) => {
                          setTypeOfLead(e.value);
                        }}
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={userDataFilter}
                        onChange={(e) => setUserDataFilter(e.value)}
                        options={userDataIds}
                        optionLabel="label"
                        placeholder="Select User"
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={branchDataValue}
                        onChange={(e) => setBranchDataValue(e.value)}
                        options={branchDataList}
                        optionLabel="label"
                        placeholder="Select Branch"
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={leadSourceValue}
                        onChange={(e) => setLeadSourceValue(e.value)}
                        options={leadSourceList}
                        optionLabel="label"
                        placeholder="Select Lead Source"
                      />
                    </div>

                    <div className="col-md mb-2">
                      <Calendar
                        value={startDateValue}
                        onChange={(e) => {
                          const start = e.value;
                          setStartDateValue(start);

                          if (!endDateValue) {
                            setEndDateValue(new Date()); // default today
                          }
                        }}
                        dateFormat="dd/mm/yy"
                        placeholder="Start Date"
                        maxDate={endDateValue ? endDateValue : new Date()}
                        showIcon
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={endDateValue}
                        onChange={(e) => setEndDateValue(e.value)}
                        dateFormat="dd/mm/yy"
                        placeholder="End Date"
                        minDate={startDateValue}
                        showIcon
                        style={{ width: "100%" }} />
                    </div>


                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">

                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={bankCategoryList}
                        value={bankCategoryValue}
                        optionLabel="label"
                        placeholder="Select Category"
                        onChange={(e) => {
                          setBankCategoryValue(e.value)
                          const bankFilter = bankListAllData.filter((item) => item.category == e.value);
                          setBankListData(bankFilter)
                          setBankDataValue([])
                        }
                        }
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        options={bankListData}
                        value={bankDataValue}
                        onChange={(e) => {
                          setBankDataValue(e.value)
                          const bankerData = {
                            searchBy: "",
                            searchText: "",
                            limit: 100000,
                            offset: 0,
                            sortBy: "",
                            sortOrder: "desc",
                            statusIn: [],
                            bankIdIn: e.value
                          };

                          fetchBankerData(bankerData)
                          setBankerDataValue([])
                        }
                        }
                        optionLabel="label"
                        placeholder="Select Bank"
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        options={bankerList}
                        value={bankerDataValue}
                        onChange={(e) =>
                          setBankerDataValue(e.value)}
                        optionLabel="label"
                        placeholder="Select Banker"
                      />
                    </div>

                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={fileStatusData}
                        value={fileStatusDataValue}
                        placeholder="Select File Status"
                        onChange={(e) => {
                          setFileStatusDataValue(e.value);
                        }}
                      />
                    </div>


                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'requestedDate', 'requestAmount', "fileStatus", "sanctionAmount", "sanctionOn", "disbursedAmount", "disbursedOn"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design-without-btn"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                     {/* <Column
                        field="fileNo"
                        header="File No."
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.fileNo}
                          </span>
                        )}
                      ></Column>*/}
                      <Column
                        field="requestedDate"
                        header="Requested Date"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {formatDate(rowData?.createdDate)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="requestAmount"
                        header="Request Amount"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.requestAmount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="fileStatus"
                        header="File Status"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.fileStatus}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="sanctionAmount"
                        header="Sanction Amount"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.sanctionAmount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="sanctionOn"
                        header="Sanction On"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.sanctionAmount > 0 ? formatDate(rowData.sanctionOn) : ""}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="disbursedAmount"
                        header="Disbursed Amount"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData.disbursedAmount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="disbursedOn"
                        header="Disbursed On"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.disbursedAmount > 0 ? formatDate(rowData?.disbursedOn) : ""}
                          </span>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  // footer={footer} 
                  // header="Click Load Button at Footer to Load More" 
                  />
                  {/*<div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>*/}
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
